import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import './Styles/fonts.css';
import './Styles/MainStyle.css';
import './Styles/myAnimate.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom'

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('topRoot')
);

reportWebVitals();
